import React from "react";

const CrossIcon = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
      <line
        x1="2"
        y1="2"
        x2="12"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <line
        x1="12"
        y1="2"
        x2="2"
        y2="12"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default CrossIcon;
